import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

export const StyledBaseLink = styled(BaseLink)`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${theme.breakpoints.only("mobile")} {
    align-items: center;
    border-block-end: 1px solid rgba(0, 0, 0, 0.2);

    padding-block-end: 24px;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  gap: 24px;
  align-self: center;

  ${theme.breakpoints.up("tablet")} {
    gap: 40px;
    align-self: start;
  }

  ${theme.breakpoints.only("mobile")} {
    &:last-child {
      ${SectionContainer}:last-child {
        border-block-end: none;

        padding-block-end: 0;
      }
    }
    &:not(:first-child) {
      padding-block-start: 24px;
    }
  }
`;

export const SectionLabel = styled.h3`
  margin-block-end: 14px;

  color: #000000;
  font-weight: 700;
  font-size: 14px;

  & ${StyledBaseLink} {
    color: #000000;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const List = styled.ul`
  ${theme.breakpoints.only("mobile")} {
    display: flex;
    flex-flow: row wrap;
    gap: 12px;
    justify-content: center;

    max-inline-size: 400px;
  }
`;

export const Item = styled.li`
  margin-block-end: 4px;
  padding-inline-end: 8px;
  &:not(:last-child) {
    border-inline-end: 1px solid rgba(0, 0, 0, 0.2);
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 14px;
    padding-inline-end: 0;
    &:not(:last-child) {
      border-inline-end: none;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-block-end: 12px;
  padding-block-end: 24px;

  border-block-end: 1px solid #000000;

  ${theme.breakpoints.up("tablet")} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: start;

    margin-block-end: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    flex: 0.7 1 0;

    inline-size: auto;
    min-block-size: 0;
    margin-block-end: 0;
    padding-block-end: 0;

    border-block-end: none;
    border-inline-end: 1px solid #000000;
  }
`;
